export default __webpack_public_path__ + "static/24934220-snap-e9dc9d0dafa3789c4fa7387354698c4c.jpg";